import { useEffect, useRef } from 'react';

/** Web: window keydown listener. `typing` is true when focus is in a text input. */
export function useKeyShortcuts(enabled: boolean, handler: (key: string, e: { ctrl: boolean; typing: boolean }) => void) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    if (!enabled) return;
    const h = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement | null)?.tagName;
      ref.current(e.key.toLowerCase(), { ctrl: e.ctrlKey || e.metaKey, typing: tag === 'TEXTAREA' || tag === 'INPUT' });
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [enabled]);
}
